/** @type {import('./index').Config} */
module.exports = {
  host: 'web.staging-traveloka.com',
  basePath: '/en-id/careers',
  apiDomain: 'cntcrr.cnt.staging-traveloka.com',
  apiHost: 'https://cntcrr.cnt.staging-traveloka.com/api',
  smartRecruitersApiHost: 'https://api.smartrecruiters.com/v1/gicompanies/Traveloka',
  imagesExternalHost: 'https://cntcrr.cnt.staging-traveloka.com',
  revalidate: 60,
  tracker: {
    gtm: {
      id: 'GTM-549JFD9',
    },
    fbPixel: {
      id: '578243957151462',
    },
    googleConversion: {
      id: 'AW-10905193727',
    },
    linkedinInsight: {
      id: '4442249',
    },
    tiktokPixel: {
      id: 'CAG67D3C77U28261LD10',
    },
  },
}
